import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    getLanguageCookie,
    resolveLanguageFromPathname,
    setLanguageCookie,
    SUPPORTED_LANGUAGES,
} from '../utils/language';

export default function usePreferredLanguageRedirect() {
    const location = useLocation();

    useEffect(() => {
        const cookieLang = getLanguageCookie();
        const pathLang = resolveLanguageFromPathname(location.pathname);

        if (location.pathname === '/') {
            return;
        }

        if (pathLang && cookieLang !== pathLang) {
            setLanguageCookie(pathLang);
        }
    }, [location.pathname]);
}
